<template>
    <base-dblclick-input
    modelType="contact"
    :model-id="clientContact.id"
    field-name="personal_phone"
    :field-value="clientContact.personal_phone"
    :canCopy="true"
    inputType="tel"
    @refetch="fetchNewClients"
  >
    <slot name="icon"></slot>
  </base-dblclick-input>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      clientContact: Object
  })

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients () {
      emit('refetch-clients')
  }
</script>